/** BULGU-016: Tüm oturumlu API istekleri httpOnly cerez taşır. */
export const axiosAuthDefaults = {
  withCredentials: true,
};
